export function validateCurrency(number: string | null) {
  if (number === null || number === "") {
    return true
  }

  return number.match(/^-?[0-9]*\.?\d{0,9}$/) !== null
}
